import { getSasToken } from "../../services/dms/dms-admin";

const onClickViewDoc = async (document, accessibilityLevel, type) => {
  const resp = await getSasToken(accessibilityLevel ? accessibilityLevel : document?.documentAccessibilityLevelName);
  if (resp && resp?.data) {
    const imageToken = resp?.data;
    const fileUrl = encodeURIComponent(`${document?.documentUrl}?${imageToken}`);

    const fileExtension = document?.documentUrl.split('.').pop().toLowerCase();
    let viewerUrl = "";
    if (fileExtension === "pdf") {
      viewerUrl = `${document?.documentUrl}${imageToken}`;
    } else if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)) {
      viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${fileUrl}`;
    } else if (fileExtension === "csv" && type === "copy") {
      // viewerUrl = window.location.origin + '/view-csv-document?src=' + 'https://coidevrgb9dd.blob.core.windows.net/public-documents/User-Registration-GCP-_1_.csv' + '&token=' + encodeURIComponent('?sv=2025-01-05&si=PublicAccessPolicy-20250514092357&sr=c&sig=USPYYQdpo8OK4lUKCewXBs%2Bb0nZynXm8bvjDYYOiC%2Fw%3D');
      viewerUrl = window.location.origin + '/view-csv-document/' + encodeURIComponent(document?.documentUrl) + '?token=' + imageToken;
    } else if (fileExtension === "csv" && type !== "copy") {
      // Fetch the CSV content as text
      fetch(`${document?.documentUrl}${imageToken}`)
        .then(response => response.text())
        .then(text => {
          const rows = text.trim().split('\n').map(row => row.split(','));
          let html = `
            <html>
            <head>
              <title>CSV Table</title>
              <style>
                table { border-collapse: collapse; }
                th, td { border: 1px solid black; padding: 4px; }
              </style>
            </head>
            <body>
              <h2>CSV Table</h2>
              <table>
          `;

          rows.forEach((row, idx) => {
            html += '<tr>';
            row.forEach(cell => {
              const safeCell = cell.replace(/</g, '&lt;');
              html += idx === 0 ? `<th>${safeCell}</th>` : `<td>${safeCell}</td>`;
            });
            html += '</tr>';
          });

          html += `
              </table>
            </body>
            </html>
          `;

          const blob = new Blob([html], { type: 'text/html' });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        });
      return;
    }
    else {
      viewerUrl = `${document?.documentUrl}${imageToken}`;
    }

    if (type === 'copy') {
      return viewerUrl;
    } else {
      window.open(viewerUrl, '_blank');
    }
  }
}

export default onClickViewDoc;